import { Container } from 'pixi.js';

export type LayerName = 'background' | 'tile' | 'seasonGround' | 'entity' | 'effects' | 'ui' | 'debug';

export class LayerManager {
  readonly root = new Container();
  readonly backgroundLayer = new Container();
  readonly tileLayer = new Container();
  readonly seasonGroundLayer = new Container();
  readonly entityLayer = new Container();
  readonly effectsLayer = new Container();
  readonly uiLayer = new Container();
  readonly debugLayer = new Container();

  constructor() {
    this.root.label = 'Stream Kingdoms Root';
    this.backgroundLayer.label = 'Background Layer';
    this.tileLayer.label = 'Tile Layer';
	this.seasonGroundLayer.label = 'Saison-Bodenebene';
    this.entityLayer.label = 'Entity Layer';
    this.effectsLayer.label = 'Effects Layer';
    this.uiLayer.label = 'UI Layer';
    this.debugLayer.label = 'Debug Layer';

    this.root.addChild(
      this.backgroundLayer,
      this.tileLayer,
      this.seasonGroundLayer,
      this.entityLayer,
      this.effectsLayer,
      this.debugLayer,
    );
  }

  getLayer(name: LayerName): Container {
    return this[`${name}Layer` as const];
  }
}
